var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    _vm._b(
      {
        class: { min: _vm.checkDisplayPcFromMobile },
        attrs: {
          app: "",
          padless: "",
          id: "footer_area",
          elevation: "1",
          height: "53px",
        },
      },
      "v-footer",
      _vm.localAttrs,
      false
    ),
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-2", attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                [_vm._v(_vm._s("表示切替 :"))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 pa-2",
                  attrs: {
                    width: "5rem",
                    height: "auto",
                    id: "back_clean_btn",
                    elevation: "0",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.switchMobileOrPC("pc")
                    },
                  },
                },
                [_vm._v(" " + _vm._s("PC") + " ")]
              ),
              _c("v-divider", {
                staticClass: "ma-0 pa-0",
                attrs: { vertical: "", id: "middle_divider" },
              }),
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 pa-2 text-none",
                  attrs: {
                    width: "7rem",
                    height: "auto",
                    id: "back_clean_btn",
                    elevation: "0",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.switchMobileOrPC("mobile")
                    },
                  },
                },
                [_vm._v(" " + _vm._s("Mobile") + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }